import { TextField } from "@material-ui/core";
import { useState } from "react";

export default function Information (){
   
    var [verif, setValue] =  useState(false);
    const onClick = () => setValue(!verif)
    if (verif)
  return(
     <div  className="stopwatch" >
      
      <span style={{width:"1000px"}}> 
      <button style={{position:'relative',top:10,right:-415 }} className="stopwatch-btn stopwatch-btn-red" onClick={onClick}>hide details</button>
      <br/>Repair details :  
      <br/> <div style={{display:'flex',justifyContent:'space-evenly'}}>
         <div> Recipe N° : <TextField></TextField></div>
           <div> Anita : <TextField></TextField></div> </div>


           <div style={{display:'flex',justifyContent:'space-evenly'}}>
         <div> Operator : <TextField></TextField></div>
           <div> Date : <TextField></TextField> </div> </div>

           <div style={{display:'flex',justifyContent:'space-evenly'}}>
         <div> Recording duration : <TextField></TextField></div>
           <div> Theoretical duration :<TextField></TextField> </div> </div>
     
    
     
      <br/>   

      </span>
  </div>)
  else 
  return(
    <div  className="stopwatch" >
<button className="stopwatch-btn stopwatch-btn-blu" onClick={onClick} >show details</button>
</div>
  )
}